import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('tr');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Mock: Gerçekte IP'ye göre dil tespit edilecek
    const detectLanguage = () => {
      // Varsayılan olarak Türkçe
      const savedLang = localStorage.getItem('preferredLanguage');
      if (savedLang) {
        setLanguage(savedLang);
      }
      setIsLoading(false);
    };

    detectLanguage();
  }, []);

  const switchLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('preferredLanguage', lang);
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, switchLanguage, t, isLoading }}>
      {children}
    </LanguageContext.Provider>
  );
};